import { useParams } from 'react-router-dom';

import MobileAppList from './MobileAppList';
import MobileAppVersions from './MobileAppVersions';

// The mobile_apps Screen: the apps as cards, or one app's versions at
// /apps/<app>/mobile_apps/versions/<id>.
const MobileApps = () => {
  const { operation, id } = useParams<{ operation?: string; id?: string }>();
  return operation === 'versions' && id ? (
    <MobileAppVersions appId={Number(id)} />
  ) : (
    <MobileAppList />
  );
};

export default MobileApps;
